<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('ShiftSchedule.shiftName')">
                    <el-input
                      size="mini"
                      v-model="formInline.shiftName"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                v-if="isPrimaryKey('USERMANAGEMENT_EDIT')"
                  type="text"
                  @click="editShift"
                  :disabled="this.selected.length != 1"
                  >{{$t('common.btn.edit')}}</el-button
                >
                <el-button
                v-if="isPrimaryKey('USERMANAGEMENT_DELETE')"
                  type="text"
                  @click="deleteShift"
                  :disabled="this.selected.length != 1"
                  >{{$t('common.btn.delete')}}</el-button
                >
                <el-button v-if="isPrimaryKey('USERMANAGEMENT_ADD')" type="text" @click="addShift">{{$t('common.btn.add')}}</el-button
                >
                <!-- <i-column
                  :listData="columns"
                  @changeSort="changeSort"
                  ref="listSet"
                ></i-column> -->
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="shiftName"
            :label="$t('ShiftSchedule.shiftName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              :disabled="isDisabled"
              size="small"
              v-model="form.shiftName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="shiftType"
            :label="$t('ShiftSchedule.numberCommuteTimes')+':'"
            :label-width="formLabelWidth"
          >
            <el-radio-group v-model="form.shiftType" size="small" @change="changeType" :disabled="isDisabled">
              <el-radio-button label="1">{{ $t('ShiftSetting.oneDayOneCommute') }}</el-radio-button>
              <el-radio-button label="2">{{ $t('ShiftSetting.oneDayTwoCommutes') }}</el-radio-button>
              <el-radio-button label="3">{{ $t('ShiftSetting.oneDayThreeCommutes') }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="isShow"
            prop="startTime1"
            :label="$t('ShiftSchedule.firstTimeWork')+':'"
            :label-width="formLabelWidth"
            class="dialong-time"
          >
            <el-time-picker
              :disabled="isDisabled"
              v-model="form.startTime1"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="任意时间点"
              @change="changeStartOne">
            </el-time-picker>
            <span style="padding: 0 10px;">{{ $t('ShiftSetting.offWork') }}</span>
            <el-time-picker
              :disabled="isDisabled"
              v-model="form.endTime1"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="任意时间点"
              @change="changeEndOne">
            </el-time-picker>
          </el-form-item>
          <el-form-item
            v-if="isTime"
            prop="startTime2"
            :label="$t('ShiftSchedule.secondJob')+':'"
            :label-width="formLabelWidth"
            class="dialong-time"
          >
            <el-time-picker
              :disabled="isDisabled"
              v-model="form.startTime2"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="任意时间点"
              @change="changeStartTwo">
            </el-time-picker>
            <span style="padding: 0 10px;">{{ $t('ShiftSetting.offWork') }}</span>
            <el-time-picker
              :disabled="isDisabled"
              v-model="form.endTime2"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="任意时间点"
              @change="changeEndTwo">
            </el-time-picker>
          </el-form-item>
          <el-form-item
            v-if="isDisplay"
            prop="startTime3"
            :label="$t('ShiftSchedule.thirdTimeWork')+':'"
            :label-width="formLabelWidth"
            class="dialong-time"
          >
            <el-time-picker
              :disabled="isDisabled"
              v-model="form.startTime3"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="任意时间点"
              @change="changeStartThree">
            </el-time-picker>
            <span style="padding: 0 10px;">{{ $t('ShiftSetting.offWork') }}</span>
            <el-time-picker
              :disabled="isDisabled"
              v-model="form.endTime3"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="任意时间点"
              @change="changeEndThree">
            </el-time-picker>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth"><div style="color: #D9001B;">{{ $t('ShiftSetting.totalShiftTime') }}{{hour}}{{ $t('ShiftSetting.hour') }}{{min}}{{ $t('ShiftSetting.minute') }}</div></el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-if="!isDisabled">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
      <!-- <el-dialog
        v-if="diaHidden"
        class="treeDialong"
        :title="$t('common.btn.roleData')"
        :visible.sync="dialogPowerVisible"
        width="520px"
        :before-close="handleClose"
        :close-on-click-modal="false"
      >
        <div>
          <div>
            <el-input
              size="small"
              :placeholder="$t('common.filterTip')"
              v-model="filterText"
            >
            </el-input>
            <div style="height: 380px">
              <el-scrollbar>
                <el-tree
                  :data="data"
                  show-checkbox
                  ref="tree"
                  node-key="label"
                  :check-on-click-node="false"
                  :default-expanded-keys="keyList"
                  :default-checked-keys="keyList"
                  :filter-node-method="filterNode"
                  :props="defaultProps"
                  :check-strictly="true"
                  @check="handCheck"
                  @check-change="checkChange"
                >
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="handleClose">{{$t('common.btn.cancel')}}</el-button
                >
            <el-button size="small" type="primary" @click="submit('form')"
              >{{$t('common.btn.confirm')}}</el-button>
          </span>
        </div>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import ShiftSetting from "./ShiftSetting";
export default ShiftSetting;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
